"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contacthero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}